<template>
  <div>
    <router-view name="dialog" :contentType="'videos'" />
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  beforeDestroy() {
    this.$store.dispatch('destroyCurrentVideo');
  },
};
</script>

<style lang="scss" scoped>
</style>
